import React from 'react'
import _ from 'lodash'
import {
  SortableElement,
  SortableContainer,
  arrayMove,
} from 'react-sortable-hoc'
import styled from 'styled-components'

// const SortableItem = SortableElement(({ renderElement, ...props }) => (
//   <ItemStyle onClick={() => props.onItemClick(props.item)}>
//     {renderElement && renderElement(props))}
//   </ItemStyle>
// ))

export const createSortableItem = ItemElement =>
  SortableElement(props => (
    <ItemStyle>
      <ItemElement {...props} />
    </ItemStyle>
  ))

const SortableList = SortableContainer(
  ({ items, renderSortableItem, ...props }) => {
    return (
      <ListStyle>
        {_.map(items, (item, index) =>
          // <SortableItem
          //   key={`item-${index}`}
          //   index={index}
          //   item={item}
          //   {...props}
          // />
          renderSortableItem({ item, index, ...props }),
        )}
      </ListStyle>
    )
  },
)

const ItemStyle = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 200px;
  border-right: 1px solid #efefef;
  border-bottom: 0;
`

const ListStyle = styled.div`
  display: flex;
  // height: 300px;
  white-space: nowrap;
  width: 100%;
  overflow: auto;
`

export default class SortableComponent extends React.Component {
  onSortEnd = ({ oldIndex, newIndex }) => {
    if (this.props.onSortEnd) {
      const items = arrayMove(this.props.items, oldIndex, newIndex)
      this.props.onSortEnd(items)
    }
  }

  render() {
    return (
      <SortableList
        {...this.props}
        items={this.props.items}
        distance={1}
        onSortEnd={this.onSortEnd}
        renderSortableItem={this.props.renderSortableItem}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/views/widgets/SortableComponent.js